import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { imputationIsLoading } from "../redux/imputations/imputationsActions";
import {
	updateImputation,
	deleteImputation,
	stopInProgressActivity,
} from "../redux/imputations/imputationsEditionActions";
import { checkOverlapping } from "../redux/imputations/imputationsChecks";
import { getCurrentDate, getTimeFromDayAndTime, getCurrentDayString } from "../time";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import MenuItem from "@mui/material/MenuItem";
import { getAllActivityTypes } from "../redux/activityTypes/activityTypesActions";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogActions from "@mui/material/DialogActions/DialogActions";
import Timepicker from "./Input/Timepicker";
import Popover from "@mui/material/Popover";
import Delete from "@mui/icons-material/Delete";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { MODULE_INTERVENTIONS } from "../redux/authorizedApps/authorizedAppsConstants";
import InterventionSelect from "./Imputations/InterventionSelect";
import { formatStatus } from "../redux/intervention/interventionStatusActions";
import { formatAddress } from "../utils";
import { loadImputationsWorkOrders } from "../redux/imputationInterventionRel/imputationInterventionRelActions";
import { getWorkOrderByCode, loadIntervention } from "../redux/intervention/interventionActions";
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ModifyImputation.css";
import { throwWarning } from "../lib/error_helper";
import CustomizedTextField from "./Input/CustomizedTextField";
import { InputLabel } from "@mui/material";
import CustomizedSelect from "./Input/CustomizedSelect";

// Be sure to include styles at some point, probably during your bootstrapping

class ModifyImputation extends Component {
	constructor(props) {
		super(props);
		let imputation = Object.assign({}, props.imputation);
		this.state = {
			imputation: imputation,
			is_modified: false,
			activityTypes: props.activityTypes === null ? [] : props.activityTypes,
			save_error: { anchor: null, message: "", display: false },
			work_order: { num: "autre" },
			workOrders: [],
		};

		this.props.loadInterventions();
	}

	//récupération des types d'activité possibles
	componentDidMount() {
		this.props.getAllActivityTypes();
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let modifiedState = prevState;
		if (nextProps.activityTypes !== prevState.activityTypes && nextProps.activityTypes !== undefined) {
			modifiedState.activityTypes = nextProps.activityTypes;
		}

		return modifiedState;
	}

	//changement de type d'activite
	updateActivity(newValue) {
		let temp = this.state.imputation;
		temp.activity = this.state.activityTypes.find((activity) => {
			return activity.id === newValue.target.value;
		});
		temp.business = "";
		temp.work_order_detail = undefined;
		this.setState({
			work_order: { num: "autre" },
			imputation: temp,
			is_modified: true,
		});
	}

	//changement de texte de la case affaire
	updateBusiness(newValue) {
		let temp = this.state.imputation;
		temp.business = newValue.target.value;
		this.setState({
			imputation: temp,
			is_modified: true,
		});
	}

	//changement d'ordre de travail
	updateWorkOrder(newWo) {
		let temp = this.state.imputation;
		let selected_wo;

		if (
			this.props.authorizedApps.filter((authorizedApp) => authorizedApp.code === MODULE_INTERVENTIONS).length > 0
		) {
			selected_wo = this.props.interventions.find((i) => {
				return i.name === newWo.num;
			});

			if (selected_wo) selected_wo = this.transformInterventionToWo(selected_wo);
		} else {
			selected_wo = this.props.workOrders.find((wo) => {
				return wo.num === newWo.num;
			});
		}

		if (selected_wo !== null && selected_wo !== undefined) {
			temp.business = selected_wo.num;
			temp.work_order_detail =
				selected_wo.num !== "autre"
					? {
							customer: selected_wo.customer,
							description: selected_wo.description,
					  }
					: undefined;
			this.setState({
				work_order: selected_wo,
				imputation: temp,
				is_modified: true,
			});
		} else {
			temp.business = "";
			temp.work_order_detail = undefined;
			this.setState({
				work_order: { num: "autre" },
				imputation: temp,
				is_modified: true,
			});
		}
	}

	transformInterventionToWo(intervention) {
		let address;
		let strAddress;
		let customer = "";

		if (intervention.delivery_address_id) address = intervention.delivery_address_id;
		else address = intervention.delivery_customer_id;

		strAddress = address ? formatAddress(address) : "";

		if (intervention.delivery_customer_id && intervention.delivery_customer_id.customer_code)
			customer =
				intervention.delivery_customer_id.name + " [" + intervention.delivery_customer_id.customer_code + "]";
		else customer = intervention.comment;

		return {
			num: intervention.name,
			customer: customer,
			address: strAddress,
			description: intervention.equipment_description + "\r\n" + intervention.failure_description,
			status: formatStatus(intervention.state, intervention.internalState),
		};
	}

	//changement de texte du commentaire
	updateCommentary(newValue) {
		let temp = this.state.imputation;
		temp.commentary = newValue.target.value;
		this.setState({
			imputation: temp,
			is_modified: true,
		});
	}

	//changement de la date de début
	updateStartTime(newValue) {
		let temp = this.state.imputation;
		temp.date_start = getTimeFromDayAndTime(this.props.day.date, newValue.toDate());
		this.setState({
			imputation: temp,
			is_modified: true,
		});
	}

	//changement de la date de fin
	updateEndTime(newValue) {
		let temp = this.state.imputation;

		let time = newValue;
		if (!time) {
			time = getCurrentDate();
			time.setHours(0, 0, 0, 0);
		}

		temp.date_end = getTimeFromDayAndTime(this.props.day.date, time.toDate());
		this.setState({
			imputation: temp,
			is_modified: true,
		});
	}

	//erreur issue des tests de validation
	onError(target, message) {
		let error = this.state.save_error;
		error.anchor = target;
		error.message = message;
		error.display = true;
		this.setState({
			save_error: error,
		});
	}

	//sortie de la page de modification
	exit() {
		this.props.end();
	}

	deleteImputation() {
		this.props.deleteImputation(this.state.imputation.id);
		this.props.end();
	}

	handleTabChange = (event, value) => {
		this.setState({ workOrderSelectValue: value });
		event.stopPropagation();
	};

	//sauvegarde de l'imputation modifiée
	async save(event) {
		this.props.loading(true);
		let target = event.currentTarget;

		let haveInterventionModuleAuthorization = this.props.authorizedApps.find(
			(authorizedApp) => authorizedApp.code === MODULE_INTERVENTIONS
		);

		if (this.state.is_modified) {
			let temp = this.state.imputation;
			temp.business = temp.business.trim();
			if (temp.activity.intervention && this.state.work_order.num === "autre" && temp.business === "") {
				this.onError(target, "Veuillez renseigner un ordre de travail");
			} else if (temp.activity.has_business && temp.business === "") {
				this.onError(target, "Veuillez renseigner une affaire");
			} else if (temp.date_start > getCurrentDate()) {
				this.onError(target, "L'horaire de début ne peut être supérieur à l'heure actuelle");
			} else if (temp.date_end > getCurrentDate()) {
				this.onError(target, "L'horaire de fin ne peut être supérieur à l'heure actuelle");
			} else if (temp.date_start >= temp.date_end) {
				this.onError(target, "L'horaire de début ne peut être supérieur ou égal à l'horaire de fin");
			} else if (await checkOverlapping(temp, false)) {
				this.onError(target, "Une activité existe déjà sur cette période. Le chevauchement n'est pas autorisé");
			} else if (haveInterventionModuleAuthorization && temp.activity.intervention && temp.in_progress) {
				this.onError(
					target,
					"Impossible de créer une imputation de type OT en cours depuis la saisie des temps. Veuillez-vous rendre sur la gestion des interventions"
				);
			} else {
				temp.date_modif = getCurrentDate();
				this.setState({
					imputation: temp,
				});

				let error = false;
				//Interruption de l'activité en cours
				let updatedActivity = await this.props.stopInProgressActivity(this.state.imputation, (message) => {
					this.onError(target, message);
					error = true;
				});

				if (!error) {
					if (!updatedActivity) {
						this.onError(target, "Erreur de traitement des données");
					} else {
						this.props.updateImputation(updatedActivity.id, updatedActivity);
						this.exit();
					}
				}
			}
		} else {
			this.exit();
		}

		this.props.loading(false);
	}

	//fermeture de la popover d'erreur
	CloseError() {
		let error = this.state.save_error;
		error.anchor = null;
		error.display = false;
		this.setState({
			save_error: error,
		});
	}

	goToIntervention() {
		if (!this.state.imputation || !this.state.imputation.business) {
			this.props.throwWarning({
				title: "OT introuvable",
			});

			return;
		}

		getWorkOrderByCode(this.state.imputation.business).then((intervention) => {
			if (!intervention) {
				this.props.throwWarning({
					title: "OT introuvable",
				});

				return;
			}

			if (
				window.confirm(
					"Vous allez être redirigé vers l'OT [" +
						intervention.name +
						"], toutes les modifications effectuées sur cette fenêtre seront perdues. Continuer?"
				)
			) {
				this.props.loadIntervention(intervention);
				this.props.history.push("/interventions/intervention");
				this.exit();
			}
		});
	}

	render() {
		let rows_activity = [];
		for (let i = 0; i < this.state.activityTypes.length; i++) {
			rows_activity.push(
				<MenuItem key={i} value={this.state.activityTypes[i].id}>
					{this.state.activityTypes[i].name}
				</MenuItem>
			);
		}
		let workOrders = this.props.workOrders;
		let rows_work_order = [];
		rows_work_order.push(
			<MenuItem key={0} value="autre">
				<Typography className="row" style={{ width: "inherit", color: "orange" }}>
					{"Saisie manuelle OT"}
				</Typography>
			</MenuItem>
		);

		let rows_work_order_groups = {};

		for (let i = 0; i < workOrders.length; i++) {
			if (rows_work_order_groups[workOrders[i].status] === undefined) {
				rows_work_order_groups[workOrders[i].status] = [];
			}

			let bgColor = "White";
			if (rows_work_order_groups[workOrders[i].status].length % 2 === 0) {
				bgColor = "#b3e5fc";
			} else {
				bgColor = "White";
			}
			rows_work_order_groups[workOrders[i].status].push(
				<MenuItem
					key={i + 1}
					value={workOrders[i].num}
					style={{
						height: "auto",
						paddingTop: 0,
						paddingBottom: 0,
						alignItems: "baseline",
						backgroundColor: bgColor,
					}}
				>
					<Typography className="row" style={{ width: "inherit" }}>
						{workOrders[i].num}
					</Typography>
					<div>
						<Typography
							className="row"
							style={{
								fontSize: 11,
								color: "#5887ee",
								fontWeight: "bold",
								overflowX: "auto",
								paddingTop: 0,
								paddingBottom: 0,
								whiteSpace: "pre-line",
							}}
						>
							{workOrders[i].customer}
						</Typography>
						<Typography
							className="row"
							style={{
								fontSize: 10,
								color: "grey",
								overflowX: "auto",
								paddingTop: 0,
								paddingBottom: 0,
								whiteSpace: "pre-line",
							}}
						>
							{workOrders[i].description ? workOrders[i].description : ""}
						</Typography>
					</div>
				</MenuItem>
			);
		}

		let tabs = [];
		Object.keys(rows_work_order_groups).map((key, index) => tabs.push(<Tab key={index} label={key} />));

		let { workOrderSelectValue } = this.state;
		rows_work_order.push(
			<div key="divTabs">
				<Tabs
					key="tabWorkOrders"
					value={workOrderSelectValue}
					onChange={this.handleTabChange}
					indicatorColor="primary"
					textColor="primary"
				>
					{tabs}
				</Tabs>
			</div>
		);
		rows_work_order.push(
			Object.keys(rows_work_order_groups).map((key, index) => {
				return workOrderSelectValue === index && rows_work_order_groups[key];
			})
		);

		return (
			<Dialog
				fullScreen={true}
				onClose={this.exit.bind(this)}
				aria-labelledby="simple-dialog-title"
				open={true}
				className="dialog-margin"
			>
				<Typography id="simple-dialog-title" style={{ display: "flex", marginLeft: "5%" }} variant="h6">
					<div style={{  width: "80%", margin: "auto" }}>Modification</div>
					<Button
						color="secondary"
						onClick={this.deleteImputation.bind(this)}
						style={{ padding: "6px", margin: "auto", width: "20%" }}
					>
						<Delete />
					</Button>
				</Typography>
				<DialogContent style={{ padding: 0 }}>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 row top_spacing">
						<div className="col-lg-6 col-md-6 col-sm-6 col-12 imputation-control-inline-row">
                            <FormControl className="row">
								<InputLabel id="activite-label">
									Activité
								</InputLabel>
								<CustomizedSelect
									label="Activité"
									labelId="activite-label"
									id="activite"
									value={this.state.imputation.activity.id}
									onChange={this.updateActivity.bind(this)}
									placeholder="Activité"
									className="full_size"
								>
									{rows_activity}
								</CustomizedSelect>
							</FormControl>
						</div>
						{this.state.imputation.activity.intervention ? (
							this.props.authorizedApps.filter(
								(authorizedApp) => authorizedApp.code === MODULE_INTERVENTIONS
							).length > 0 ? (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12 imputation-control-inline-row">
                                    <InterventionSelect
                                        workOrders={this.props.interventions.map((i) => {
                                            return this.transformInterventionToWo(i);
                                        })}
                                        defaultValue={this.state.work_order}
                                        defaultWorkOrder={this.state.work_order}
                                        updateWorkOrder={this.updateWorkOrder.bind(this)}
                                    />
                                </div>
							) : (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12 imputation-control-inline-row">
                                    <InterventionSelect
                                        workOrders={this.props.workOrders}
                                        defaultValue={0}
                                        defaultWorkOrder={this.state.work_order}
                                        updateWorkOrder={this.updateWorkOrder.bind(this)}
                                    />
                                </div>
							)
						) : this.state.imputation.activity.has_business ? (
							<div className="col-lg-6 col-md-6 col-sm-6 col-12">
								<div className="row">
									<CustomizedTextField
										error={this.state.imputation.business === ""}
										id="affaire"
										label={this.state.imputation.business === "" ? "Saisir une affaire" : "Affaire"}
										className="full_size"
										value={this.state.imputation.business}
										onChange={this.updateBusiness.bind(this)}
										margin="normal"
									/>
								</div>
							</div>
						) : null}
						{this.state.imputation.activity.intervention && this.state.work_order.num === "autre" ? (
							<div className="col-lg-6 col-md-6 col-sm-6 col-12 row">
								<div className="without-side-padding col-lg-10 col-md-10 col-sm-8 col-8">
									<CustomizedTextField
										error={this.state.imputation.business === ""}
										id="affaire"
										label={
											this.state.imputation.business === ""
												? "Saisir l'ordre de travail"
												: "Ordre de travail"
										}
										className="full_size"
										value={this.state.imputation.business}
										onChange={this.updateBusiness.bind(this)}
										margin="normal"
									/>
								</div>
								<div className="without-side-padding col-lg-2 col-md-2 col-sm-4 col-4 imputation-control-inline-btn">
									<Button
										variant="contained"
										size="small"
										onClick={this.goToIntervention.bind(this)}
										className="div-center"
									>
										<FontAwesomeIcon icon={faClipboardList} className="fa-2x" alt="Intervention" />
									</Button>
								</div>
							</div>
						) : null}
						{!this.state.imputation.activity.driving ? (
							<div className="col-lg-6 col-md-6 col-sm-6 col-12">
								<CustomizedTextField
									id="commentary"
									label="Commentaire"
									placeholder="Commentaire ..."
									multiline
									rowsMax="3"
									value={this.state.imputation.commentary}
									className={this.props.textField + " full_size"}
									onChange={this.updateCommentary.bind(this)}
									margin="normal"
								/>
							</div>
						) : null}
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
						<div className="col-lg-6 col-md-6 col-sm-6 col-12 imputation-control-inline-row">
							<FormControl className=" full_size">
								<Timepicker
									id="time_start"
									mode="24h"
									label="Heure de début"
									className="full_size "
									onChange={this.updateStartTime.bind(this)}
									value={this.state.imputation.date_start}
								/>
							</FormControl>
						</div>
						<div className="col-lg-6 col-md-6 col-sm-6 col-12 imputation-control-inline-row">
							<FormControl className="full_size">
								<Timepicker
									id="time_end"
									mode="24h"
									label="Heure de fin"
									className="full_size "
									onChange={this.updateEndTime.bind(this)}
									value={this.state.imputation.date_end}
								/>
							</FormControl>
						</div>
					</div>
				</DialogContent>
				<DialogActions>
					<div className="full_size">
						<Button
							color="secondary"
							className="col-lg-6 col-md-6 col-sm-6 col-6"
							onClick={this.exit.bind(this)}
						>
							Annuler
						</Button>
						<Button
							color="primary"
							className="col-lg-6 col-md-6 col-sm-6 col-6"
							onClick={this.save.bind(this)}
						>
							Enregistrer
						</Button>
						<Popover
							open={this.state.save_error.display}
							anchorEl={this.state.save_error.anchor}
							onClose={this.CloseError.bind(this)}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "center",
							}}
						>
							<div className="error" >
								{this.state.save_error.message}
							</div>
						</Popover>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		activityTypes: state.activityTypes,
		workOrders: state.workOrders,
		authorizedApps: state.authorizedApps,
		interventions: state.interventionsImputations.allInterventions,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		deleteImputation: (id) => dispatch(deleteImputation(id)),
		updateImputation: (id, imputation) => dispatch(updateImputation(id, imputation)),
		getAllActivityTypes: () => dispatch(getAllActivityTypes()),
		loading: (value) => dispatch(imputationIsLoading(value)),
		loadInterventions: () => dispatch(loadImputationsWorkOrders()),
		stopInProgressActivity: (imputation, catchFunction) =>
			dispatch(stopInProgressActivity(imputation, catchFunction)),
		loadIntervention: (intervention) => dispatch(loadIntervention(intervention)),
		throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
	};
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ModifyImputation);
